import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Typography,
  Tag,
  Menu,
  Dropdown,
  Icon,
  Button,
  Modal,
  Select,
  DatePicker,
  message,
  Table,
} from "antd";
import moment from "moment";

import { fetchReportListApi, deleteReportListApi } from "utils/apiService";

import Loader from "../../components/Loader/Loader";
import emptyImage from "../../media/empty-reports-img.svg";
import "./generated-reports.scss";

const { Text } = Typography;
const { Option } = Select;
const ReportsTableColumns = (props) => {
  const {
    toggleDeleteModal,
    addDeleteReport,
    pageDetails,
    handlePageChange,
    tableLoading,
    reportList,
    pageNum,
  } = props;
  const columns = [
    {
      title: "Report Title",
      dataIndex: "reportTitle",
      key: "reportTitle",
      render: (data) => {
        return (
          <Text
            style={{
              fontStyle: "normal",
              fontWeight: "bold",
              fontSize: "16px",
              lineHeight: "24px",
              color: "#181818",
            }}
          >
            {data ? data : "-"}
          </Text>
        );
      },
    },
    {
      title: "Generated On",
      dataIndex: "dateCreated",
      key: "dateCreated",
      render: (data) => {
        return (
          <Text
            style={{
              fontStyle: "normal",
              fontWeight: "normal",
              fontSize: "14px",
              lineHeight: "22px",
              color: "#747474",
            }}
          >
            {data ? data : "-"}
          </Text>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let { color, tag } = status
          ? { color: "green", tag: "Completed" }
          : { color: "yellow", tag: "Processing" };
        return (
          <Tag color={color} key={tag}>
            {tag.toUpperCase()}
          </Tag>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "reportUrl",
      key: "reportUrl",
      render: (url) =>
        url ? (
          <a
            href={url}
            target={"_blank"}
            rel="noopener noreferrer"
            style={{ color: "green" }}
          >
            Download Report
          </a>
        ) : null,
    },
    {
      title: "",
      dataIndex: "uuid",
      key: "actions",
      render: (data) => {
        return !props.viewOnly ? (
          <Dropdown
            placement={"bottomLeft"}
            overlay={
              <Menu>
                <Menu.Item
                  onClick={(e) => {
                    toggleDeleteModal();
                    addDeleteReport([data]);
                  }}
                >
                  <Text style={{ color: "#F5222D" }}>Delete</Text>
                </Menu.Item>
              </Menu>
            }
          >
            <Icon
              type="more"
              onClick={(e) => {
                e.stopPropagation();
              }}
              style={{ fontSize: "16px", color: "#747474" }}
            />
          </Dropdown>
        ) : (
          <></>
        );
      },
    },
  ];
  return (
    <Table
      columns={columns}
      dataSource={reportList}
      //   pagination={{
      //     showQuickJumper: true,
      //     current: pageNum,
      //     pageSize: pageDetails.pageSize,
      //     total: pageDetails.pageSize * pageDetails.totalPages,
      //   }}
      //   onChange={(pagination) => {
      //     handlePageChange(pagination);
      //   }}
      //   loading={tableLoading}
    />
  );
};

export default ReportsTableColumns;
